import { services } from "../../../../api";
import { ChatRequest } from "../../../../interfaces/api/chat";
import { submitStreaming, abortStreaming } from "../../qa/actions";
import { ChatType } from "../../../../shared/utils/enums";
import { Form } from "../../../../interfaces/api/form";

export const submitGenioStreaming = async (
  request: ChatRequest & { patientId: number },
  onChunk: (chunk: string) => void,
  onComplete: () => void,
  onError: (error: string) => void,
) => {
  await submitStreaming(
    {
      ...request,
      type: ChatType.ClinicalCase,
    },
    onChunk,
    onComplete,
    onError,
  );
};

export const abortGenioStreaming = abortStreaming;

export const submitPatientReport = async (form: any) => {
  try {
    const response = await services.reports.addReport(form);
    return response.result === "success";
  } catch (error) {
    console.error("Error submitting patient report:", error);
    throw error;
  }
};

export const updatePatientReport = async (
  id: string,
  form: any,
): Promise<boolean> => {
  try {
    const res = await services.reports.updateReport(id, form);
    return res.result === "success";
  } catch (err) {
    console.error("Error updating report:", err);
    return false;
  }
};

export const fetchReports = async (patientId: number) => {
  try {
    const response = await services.reports.getReportsByPatient(patientId);
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return null;
  }
};

export const getReportForms = async (): Promise<Form[]> => {
  try {
    const response = await services.reports.getForms();
    return response.content;
  } catch (error) {
    console.error("Error fetching report forms:", error);
    throw error;
  }
};
